export default __webpack_public_path__ + "static/media/gp-img.6d0370c4.webp";